<template>
	<popup class="save-asset-popup" title="Save element as an asset" @close="close" >
		<template v-slot:content>
			<div class="layout-column flex __content">
				<div>
					<input-field small label="Asset name" v-model="asset.name" />
				</div>
				<div class="layout-row flex-center margin-t-25">
					<select-field class="flex margin-r-10" label="name" v-model="asset.group_id" searchable caption="Asset group"
					              :options="groups" small />
					<v-button class="small-btn" flat @click="$emit('newGroup')"
					          v-tippy content="New asset group" :icon="require('@/assets/img/plus_icon_gray.svg')" />
				</div>
			</div>
		</template>
		<template v-slot:actions>
			<v-button label="Create asset" slim :loading="loading" @click="add()" :disabled="!asset.group_id || !asset.name" />
			<v-button label="Cancel" slim border @click="close" />
		</template>
	</popup>
</template>

<script>
import Popup from '@/components/base/popup';
import VButton from '@/components/base/v-button';
import InputField from '@/components/base/input-field';
import {mapGetters} from "vuex";
import API from '@/api';
import SelectField from "@/components/base/select-field";
import html2canvas from 'html2canvas';
import NewAssetGroupPopup from "@/modules/page-editor/src/components/sidebar/popups/new-asset-group-popup";
import {generateId} from "@/modules/page-editor/src/store/editor";

export default {
	name: "save-asset-popup",
	components: {NewAssetGroupPopup, SelectField, InputField, Popup, VButton},
	props:['element'],
	mixins:[API],
	data() {
		return {
			loading: false,
			newGroupOpen: false,
			asset:{
				name:'',
				group_id:null,
			}
		}
	},
	computed:{
		...mapGetters(['page_findAll','page_findChildren','page_findChild',
		               'numbers', 'page_findRows', 'page_findRow', 'current_popup', 'savedAssetGroups']),
		pageId(){
			return this.$store.state.page.initial ? this.$store.state.page.initial.page : '';
		},
		stepId(){
			return this.$store.state.page.initial ? this.$store.state.page.initial.step : '';
		},
		funnelId(){
			return this.$store.state.page.initial ? this.$store.state.page.initial.funnel : '';
		},
		groups() {
			return this.savedAssetGroups;
		}
	},
	methods: {
		close() {
			this.$emit('close');
		},
		findEl() {
			if (!this.element) return null;

			return document.querySelector(`.page-container.content-root [data-eid="${this.element.id}"]`)
		},
		resizeCanvas(dataUrl, newHeight, newWidth, callback) {
			let extra_canvas = document.createElement("canvas");
			extra_canvas.setAttribute('width',newWidth);
			extra_canvas.setAttribute('height',newHeight);
			let ctx = extra_canvas.getContext('2d');
			ctx.imageSmoothingEnabled = true;

			let image = new Image();
			image.onload = () => {
				this.scaleToFit(ctx, extra_canvas, image)
				callback(extra_canvas)
			};
			image.src = dataUrl;
		},
		fit(parentWidth, parentHeight, childWidth, childHeight, scale = 1, offsetX = 0.5, offsetY = 0.5) {
				const childRatio = childWidth / childHeight
				const parentRatio = parentWidth / parentHeight
				let width = parentWidth * scale
				let height = parentHeight * scale

				height = width / childRatio

				return {
					width,
					height,
					offsetX: 0,//(parentWidth - width) * offsetX,
					offsetY: (childRatio > parentRatio) ? (parentHeight - height) * offsetY : 0
				}
		},
		scaleToFit(ctx, canvas, img) {
			let {
				offsetX,
				offsetY,
				width,
				height
			} = this.fit(canvas.width, canvas.height, img.width, img.height)

			ctx.drawImage(img, offsetX, offsetY, width, height)
		},
		findBlocks(block) {
			let children = [];

			if (block.type==='twoStepForm') {
				block.step1Children && block.step1Children.forEach(c => {

					// Clone each child and add to global children list.
					let oldChild = this.page_findChild(c);
					if (!oldChild) return;

					let subRes = this.findBlocks(oldChild)
					if (subRes)
						children.push(...subRes.children)
				});
				block.step2Children && block.step2Children.forEach(c => {

					// Clone each child and add to global children list.
					let oldChild = this.page_findChild(c);
					if (!oldChild) return;

					let subRes = this.findBlocks(oldChild)
					if (subRes)
						children.push(...subRes.children)
				});
			} else if (block.type==='faq') {
				block.children && block.children.forEach(c => {

					// Clone each child and add to global children list.
					let oldChild = this.page_findChild(c);
					if (!oldChild) return;

					let subRes = this.findBlocks(oldChild)
					if (subRes)
						children.push(...subRes.children)
				});
			} else if (block.type==='container') {
				block.attributes.basic.boxes.forEach(box => {
					box.children && box.children.forEach(c => {

						// Clone each child and add to global children list.
						let oldChild = this.page_findChild(c);
						if (!oldChild) return;

						let subRes = this.findBlocks(oldChild)
						if (subRes)
							children.push(...subRes.children)
					});
				});
			} else {
				// do nothing.
			}

			children.push(block) // append the new container block itself.
			return {children}
		},
		findRow(row) {
			let children = [];

			row.cols.forEach(col => {
				col.children.forEach(c => {
					let child = this.page_findChild(c, !!this.current_popup)
					if (!child) return; // nothing to do

						let res = this.findBlocks(child)
						children.push(...res.children);
				});
			});

			return {children}
		},
		findAllBlocks() {
			if (this.element.type==='row') {

				let {children} = this.findRow(this.element)
				return {element:this.element, rows:[], children:children}

			} else if (this.element.type==='section') {

				let rows = [];
				let allChildren = [];

				this.element.children.forEach(rowId => {
					let row = this.page_findRow(rowId, !!this.current_popup)
					let {children} = this.findRow(row)
					rows.push(row)
					allChildren.push(...children)
				})
				return {rows, element:this.element, children: allChildren}

			} else {

				let {children} = this.findBlocks(this.element)
				return {rows:[], element: this.element, children: children}
			}
		},
		async addInner() {
			try {
				let el = this.findEl()
				if (!el) {
					this.$error(this.element,`Couldn't find element`)
					return
				}

				// this.asset.html = el.outerHTML
				this.asset.element_type = this.element.type;
				this.asset.structure = JSON.stringify(this.element)
				let {children,rows,element} = this.findAllBlocks()
				this.asset.rows = JSON.stringify(rows||[])
				this.asset.structure = JSON.stringify(element||{})
				this.asset.children = JSON.stringify(children||[])

				this.asset.source_funnel_id = this.funnelId
				this.asset.source_step_id = this.stepId
				this.asset.source_page_id = this.pageId

				html2canvas(el, {
					allowTaint:true,
					letterRendering: 1,
					useCORS: true,
					logging:false,
					// width: 400,
					// height: 400,
					// scale:1,
					onclone: function (clonedDoc) {
						let root = clonedDoc.querySelector('.page-container.content-root')
						let x = root.querySelector('.element_wrpr.current')
						let s = root.querySelector('.section.current')
						let r = root.querySelector('.section_row.current')
						if (x) x.classList.remove('current')
						if (s) s.classList.remove('current')
						if (r) r.classList.remove('current')

						// root.classList.remove('mobile_grid')
						// root.classList.remove('desktop_grid')
						// root.classList.add('tablets_grid')

						root.querySelectorAll('.element-hidden').forEach(x=>{
							x.classList.add('hidden')
						})

						root.querySelectorAll('.wrapper-docking').forEach(x=>{
							x.remove()
						})
						root.querySelectorAll('.image-slider .button.delete-btn').forEach(x=>{
							x.remove()
						})
						root.querySelectorAll('.image-slider .button.add-slide').forEach(x=>{
							x.remove()
						})

						root.querySelectorAll('.two-step-form .plus_input_wrpr').forEach(x=>{
							x.classList.add('hidden')
						})

						// root.style.width = "560px"
						// root.style.maxWidth = "560px"
					}
				}).then((canvas) => {

					this.resizeCanvas(canvas.toDataURL(), 160*2, 280*2, (canvas)=>{
						this.asset.thumbnail_url = canvas.toDataURL();

						this.api.assets.createAsset(this.asset).then((res)=>{
							if (res && res.error) {
								throw res
							}
							let group = this.groups.find(x=>x.id===res.group_id)
							if (group) {
								if (!group.assets) {
									console.warn("assets is null", JSON.parse(JSON.stringify(group)))
									group.assets = [];
								}
								group.assets.push(res)
							}
							this.$emit('done', res);

							this.loading = false;
						}).catch(()=>{
							this.loading = false;
						});
					})

				}).catch(()=>{
					this.loading = false;
				});

				return
			} catch (e) {
				this.$error(e)
			} finally {
			}
		},
		async add() {
			this.loading = true;

			setTimeout(()=> {
				this.addInner()
			},300)
		}
	},
	created() {
	},
	mounted() {
		if (this.groups && this.groups.length > 0)
			this.asset.group_id = this.groups[0].id;
	}
}
</script>
<style lang="scss" scoped>
.__content {
	padding: 20px 10px 10px 10px;
}
</style>
<style lang="scss" >
.save-asset-popup {
	.popup {
		max-width: 450px;
	}
	.content {
		//padding: 0;
		p {
			margin-block-start: 5px;
			margin-block-end: 5px;
		}
	}
	.popup_header {
		margin: 0;
	}
}
</style>
